import React from "react";

import { ForumAPI } from "./forum_api_context";

class IPController {
  private ip: string | null;

  constructor() {
    this.ip = null;
    this.start();
  }

  private async start() {
    try {
      const forumAPI = new ForumAPI();
      const results = await forumAPI.fetchIP();
      this.ip = results.ip;
    } catch (e) {
      // If we failed to contact the server, try again in one second.
      //   setTimeout(this.start.bind(this), 1000);
      console.warn("Failed to fetch IP");
    }
  }

  getIP() {
    if (this.ip === null) {
      return "";
    }
    return this.ip;
  }
}

export const IPContext = React.createContext(new IPController());
